export default "__VITE_ASSET__Dp466Si2__"